


import React from 'react';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

interface LinkifyProps {
  children: string;
}

// Only match http/https URLs — intentionally excludes custom deep-link schemes
// (e.g. instagram://, fb://) which would cause ERR_UNKNOWN_URL_SCHEME.
const urlRegex = /\bhttps?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]/ig;

const Linkify: React.FC<LinkifyProps> = ({ children }) => {
  if (!children) {
    return null;
  }

  const parts = children.split(urlRegex);
  const matches = children.match(urlRegex);

  const handleLinkClick = async (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();
    if (Capacitor.isNativePlatform()) {
      // On Android/iOS, Browser.open() launches the true system browser (Chrome/Safari).
      // This is the ONLY reliable way — target="_blank" and window.open() both
      // open an in-app WebView that cannot handle instagram:// redirects.
      await Browser.open({ url });
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {matches && matches[i] && (
            <a
              href={matches[i]}
              onClick={(e) => handleLinkClick(e, matches[i])}
              rel="noopener noreferrer"
              className="hover:underline break-all"
              style={{ color: '#e73e7b', overflowWrap: 'anywhere' }}
            >
              {matches[i]}
            </a>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default Linkify;
